module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Heavy-aefa146e2a822211715a08b5df5a99a6.eot";